import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { LogoutDirective } from './logout.directive';

@NgModule({
  declarations: [LogoutDirective],
  imports: [CommonModule],
  exports: [LogoutDirective]
})
export class LogoutModule {}

export * from './logout.directive';
export * from './logout.service';
